<template>
  <div class="goods-card">
    <div class="title">
      <div class="name">
        <div class="label elip--multiple">
          {{ props.name }}
        </div>
        <slot name="name"></slot>
      </div>
      <div class="desc" v-if="props.description">{{ props.description }}</div>
    </div>
    <div class="content"><slot name="content"></slot></div>
    <div class="bottom" @click="selInfo">
      <div>查看详情</div>
      <auth-img src="@/assets/img/chat/agreement/right.png" class="img" />
    </div>
  </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
const props = defineProps({
  name: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['selInfo'])
const selInfo = () => {
  emit('selInfo')
}
</script>
<style scoped lang="scss">
.goods-card {
  background: #fff9f5;
  border: 1px solid #dfc9ba;
  border-radius: 12px;
  .title {
    display: grid;
    justify-content: space-between;
    padding: 14px 16px 0 14px;
    align-items: center;
    grid-template-columns: 1fr 120px;
    margin-bottom: 8px;
    .label {
      // max-width: 76px;
      -webkit-line-clamp: 1;
    }
    .name {
      position: relative;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
    }
    .desc {
      font-size: 14px;
      color: #333333;
      text-align: right;
    }
    .description {
      font-weight: bold;
      font-size: 14px;
      color: #333333;
    }
  }
  .content {
    padding: 0px 16px 14px 16px;
  }
  .bottom {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    border-top: 1px solid #f2e0d4;
    font-weight: 400;
    font-size: 14px;
    color: #8c563f;
    .img {
      width: 14px;
      height: 14px;
    }
  }
}
</style>
